import React, { Component } from "react";
import {withRouter, Link} from 'react-router-dom';

import {PageWrapper} from 'components/PageWrapper';

import HttpClient from 'services/HttpClient';

const SAMPLE_CONTENT_API = '/api/v1/free_samples?sample_type=video';

@withRouter
class SampleVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
    };
  }

  componentDidMount() {
    new HttpClient().get(`${SAMPLE_CONTENT_API}&page=1&per_page=10`)
    .then(({ body }) => {
      this.setState({
        videos: body.data.free_sample,
      });
    })
  }

  nextPage = page => {

    new HttpClient().get(`${SAMPLE_CONTENT_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      this.setState({
        videos: body.data.free_sample,
      });
      window.scrollTo({top: 0});
    });
  };

  render() {
    const { videos } = this.state;

    return videos.length > 0 ? (
      <PageWrapper className="sample-content-page">
        <div className="page-container">
          <h2>Sample Videos</h2>
        </div>
        <div className="sample-content-container">
          {videos.map((content) => (
            <div key={`content_${content.id}`} className="sample-content">
              <p>{content.title}</p>
              <div
                dangerouslySetInnerHTML={{__html: content.video_url}}
              />
            </div>
          ))}
        </div>
      </PageWrapper>
    ) : null;
  }
};

export default SampleVideos;



// WEBPACK FOOTER //
// ./src/modules/landing/containers/SampleVideos.js